import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import type { UserRole } from '../types';

interface Props {
  roles: UserRole[];
}

export default function ProtectedRoute({ roles }: Props) {
  const { appUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-600 border-t-transparent" />
      </div>
    );
  }

  if (!appUser) return <Navigate to="/login" replace />;
  if (!roles.includes(appUser.role)) return <Navigate to="/" replace />;

  return <Outlet />;
}
